<template>
  <div>
    <div class="header2">
      <van-nav-bar
          title="创建调查"
          left-text="返回"
          left-arrow
          @click-left="goBack"
      />
    </div>
    <van-form @submit="creatSurvey">
      <div class="form-sty">
        <van-field
            required
            v-model="title"
            label="调查名称"
            placeholder="调查名称"
            :rules="[{ required: true, message: '请填写调查名称' }]"
        />
      </div>
      <div class="created-tit" style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import URL from '@/api/api'

export default {
  data() {
    return {
      title: "",
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    creatSurvey() {
      let data={
          openId:localStorage.getItem("openid"),
          title: this.title
        }
      this.$fetchPost(URL.saveTitle.url, data).then(res => {
        if (res.data.code == 20000) {
          this.$router.push({ path: '/editQuestionnaire/details', query: { typeId: res.data.data.id }})
        }
      })
    }
  },
};
</script>
<style scoped>
.created-tit >>> .van-button--info {
  width: 95%;
  border-radius: 5px;
  border: 1px solid;
}

.form-sty >>> .van-cell {
  display: block;
}

.form-sty >>> .van-field__control {
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  padding: 10px 5px;
}

</style>
